import { IForecastVerticalDetail } from '../../interfaces/iforecast-vertical-detail';
import { Division } from '../division';
import { ForecastVertical } from '../forecast-vertical';

export class ForecastVerticalDetailBase {
  ForecastVerticalDetailId: number;
  ForecastVerticalId: number;
  CopasCoop: number | null;
  Date: Date | null;
  DevDrill: number | null;
  ExplCompl: number | null;
  ExplDrill: number | null;
  Facilities: number | null;
  CaseId: string;
  Ffg: number | null;
  Frac: number | null;
  GrossBoe: number | null;
  GrossCondensate: number | null;
  GrossGas: number | null;
  GrossMboed: number | null;
  GrossMcfe: number | null;
  GrossMmcfed: number | null;
  GrossNgl: number | null;
  GrossOil: number | null;
  GrossWater: number | null;
  Land: number | null;
  Loe: number | null;
  NetBoe: number | null;
  NetCondensate: number | null;
  NetGas: number | null;
  NetMboed: number | null;
  NetMcfe: number | null;
  NetMmcfed: number | null;
  NetNgl: number | null;
  NetOil: number | null;
  NetWater: number | null;
  Ngp: number | null;
  PopWells: number | null;
  Quarter: string | null;
  RigCount: number | null;
  Seismic: number | null;
  Spud: number | null;
  Workover: number | null;
  Year: number | null;
  Pdp: string;
  WellId: number;
  DaysOn: number;
  UnriskedOil: number;
  UnriskedGas: number | null;
  UnriskedWater: number;
  OilBopd: number;
  GasMcfpd: number;
  DryGasMcfpd: number;
  NglBpd: number;
  WaterBpd: number;
  Gross2StreamBoe: number;
  Gross3StreamBoe: number;
  NetOilVolumeBpd: number;
  NetWetGasVolumeMcfpd: number;
  NetDryGasVolumeMcfpd: number;
  NetNglBpd: number;
  Net2StreamBoe: number;
  Net3StreamBoe: number;
  NetJvOilVolumeBpd: number | null;
  NetJvWetGasVolumeMcfpd: number | null;
  NetJvDryGasVolumeMcfpd: number | null;
  NetJvNglBpd: number | null;
  NetJv2StreamBoe: number | null;
  NetJv3StreamBoe: number | null;
  DivisionId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Division?: Division;
  ForecastVertical?: ForecastVertical;

  constructor(item?: IForecastVerticalDetail) {
    if (item) {

      this.ForecastVerticalDetailId = item.ForecastVerticalDetailId;
      this.ForecastVerticalId = item.ForecastVerticalId;
      this.CopasCoop = item.CopasCoop;
      this.Date = item.Date ? new Date(item.Date) : null;
      this.DevDrill = item.DevDrill;
      this.ExplCompl = item.ExplCompl;
      this.ExplDrill = item.ExplDrill;
      this.Facilities = item.Facilities;
      this.CaseId = item.CaseId;
      this.Ffg = item.Ffg;
      this.Frac = item.Frac;
      this.GrossBoe = item.GrossBoe;
      this.GrossCondensate = item.GrossCondensate;
      this.GrossGas = item.GrossGas;
      this.GrossMboed = item.GrossMboed;
      this.GrossMcfe = item.GrossMcfe;
      this.GrossMmcfed = item.GrossMmcfed;
      this.GrossNgl = item.GrossNgl;
      this.GrossOil = item.GrossOil;
      this.GrossWater = item.GrossWater;
      this.Land = item.Land;
      this.Loe = item.Loe;
      this.NetBoe = item.NetBoe;
      this.NetCondensate = item.NetCondensate;
      this.NetGas = item.NetGas;
      this.NetMboed = item.NetMboed;
      this.NetMcfe = item.NetMcfe;
      this.NetMmcfed = item.NetMmcfed;
      this.NetNgl = item.NetNgl;
      this.NetOil = item.NetOil;
      this.NetWater = item.NetWater;
      this.Ngp = item.Ngp;
      this.PopWells = item.PopWells;
      this.Quarter = item.Quarter;
      this.RigCount = item.RigCount;
      this.Seismic = item.Seismic;
      this.Spud = item.Spud;
      this.Workover = item.Workover;
      this.Year = item.Year;
      this.Pdp = item.Pdp;
      this.WellId = item.WellId;
      this.DaysOn = item.DaysOn;
      this.UnriskedOil = item.UnriskedOil;
      this.UnriskedGas = item.UnriskedGas;
      this.UnriskedWater = item.UnriskedWater;
      this.OilBopd = item.OilBopd;
      this.GasMcfpd = item.GasMcfpd;
      this.DryGasMcfpd = item.DryGasMcfpd;
      this.NglBpd = item.NglBpd;
      this.WaterBpd = item.WaterBpd;
      this.Gross2StreamBoe = item.Gross2StreamBoe;
      this.Gross3StreamBoe = item.Gross3StreamBoe;
      this.NetOilVolumeBpd = item.NetOilVolumeBpd;
      this.NetWetGasVolumeMcfpd = item.NetWetGasVolumeMcfpd;
      this.NetDryGasVolumeMcfpd = item.NetDryGasVolumeMcfpd;
      this.NetNglBpd = item.NetNglBpd;
      this.Net2StreamBoe = item.Net2StreamBoe;
      this.Net3StreamBoe = item.Net3StreamBoe;
      this.NetJvOilVolumeBpd = item.NetJvOilVolumeBpd;
      this.NetJvWetGasVolumeMcfpd = item.NetJvWetGasVolumeMcfpd;
      this.NetJvDryGasVolumeMcfpd = item.NetJvDryGasVolumeMcfpd;
      this.NetJvNglBpd = item.NetJvNglBpd;
      this.NetJv2StreamBoe = item.NetJv2StreamBoe;
      this.NetJv3StreamBoe = item.NetJv3StreamBoe;
      this.DivisionId = item.DivisionId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Division = new Division(item.Division);
      this.ForecastVertical = new ForecastVertical(item.ForecastVertical);
    }
  }
}